import { buildRouteHead } from "@/lib/seo/routeHead";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/privacy")({
  head: () => buildRouteHead("/privacy", { noIndex: true }),
  beforeLoad: () => {
    throw redirect({ to: "/en/privacy-policy", replace: true });
  },
});
